module.exports = __webpack_public_path__ + "static/cherryTree_logo-804b1e54b026b2281f5665378ff02b7a.png";